import React from "react";

export type FormTab = {
   tabs: {
      elements: Record<string, any>;
      id: string;
      name: string;
   }[];
};

export interface CallManagerProps {
   tabs: FormTab;
   parentId: string;
}

export type FormIds = { formId: number | null; dataId?: number | null };

export type CallManagerButton = {
   label: string;
   icon: React.ReactNode;
   onClick?: (() => void) | undefined;
   disabled?: boolean;
   isActive?: boolean;
   isEndCall?: boolean;
   className?: string;
};

export type CallManagerInfo = Pick<CallManagerButton, "label" | "icon">;

export type CallManagerButtonGroup = {
   buttons: CallManagerButton[];
   className?: string;
   isPhoneCallActions?: boolean;
};

export enum CallStep {
   PLANNED = "PLANNED",
   ACTIVE = "ACTIVE",
   COMPLETED = "COMPLETED",
}

export enum PhoneCallStatus {
   ACTIVE = "active",
   ON_HOLD = "onHold",
   ENDED = "ended",
   CONNECTING = "connecting",
}
